export default "__VITE_ASSET__Co0OpWsR__"